import { useEffect, useState } from "react";
import { UseRepositoryResult } from "../types/repositoryTypes";
import { parseGvizSheetResponse } from "../utils/parseGoogleSheetGviz";

const CONFIG_ERROR =
  "Thiếu cấu hình REACT_APP_SHEET_ID hoặc REACT_APP_SHEET_NAME.";
const FETCH_ERROR = "Không tải được dữ liệu. Vui lòng thử lại sau.";

function buildSheetUrl(sheetId: string, sheetName: string): string {
  const base = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?`;
  const query = encodeURIComponent("Select *");
  return `${base}&sheet=${encodeURIComponent(sheetName)}&tq=${query}`;
}

const useRepository = (): UseRepositoryResult => {
  const [repositoryList, setRepositoryList] = useState<
    UseRepositoryResult["repositoryList"]
  >([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const sheetId = process.env.REACT_APP_SHEET_ID;
    const sheetName = process.env.REACT_APP_SHEET_NAME;

    if (!sheetId || !sheetName) {
      setError(CONFIG_ERROR);
      setLoading(false);
      return;
    }

    const url = buildSheetUrl(sheetId, sheetName);
    let cancelled = false;

    setLoading(true);
    setError(null);

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        return res.text();
      })
      .then((text) => {
        if (cancelled) return;
        setRepositoryList(parseGvizSheetResponse(text));
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("useRepository:", err);
        setError(FETCH_ERROR);
        setRepositoryList([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { repositoryList, loading, error };
};

export default useRepository;
